import { CalendarCard, CalendarCardsParams } from '../../types'
import { apiClient } from '../client'

export const calendarApi = {
  getCardsByMonth: (params: CalendarCardsParams) =>
    apiClient.get<CalendarCard[]>('/cards/calendar', { params }),
}
